import React, { useState, useCallback } from 'react'
import { Grid, Card } from '@mui/material'
import { SimpleForm, Confirm, useGetOne, useUpdate, useNotify, useRefresh } from 'react-admin'

import { JobOpportunityBanner } from './type'
import { FormBottomToolbarWithPermission } from '../../components/form'

import { ImageDesktopInput } from '../../components/inputs/ImageDesktopInput'

const JobOpportunityBannerEdit = (): JSX.Element => {
  const [updateData, setUpdateData] = useState({} as JobOpportunityBanner)

  const { data: jobOpportunityBannerData, isLoading: newsLoading } = useGetOne(
    'job-opportunity-banner',
    { id: '' },
  )
  const [open, setOpen] = useState(false)
  const refresh = useRefresh()
  const notify = useNotify()
  const handleDialogClose = (): void => setOpen(false)

  const onSuccess = useCallback(async (): Promise<void> => {
    notify('update success', { type: 'success' })
    refresh()
  }, [notify, refresh])

  const onError = useCallback(
    (error): void => {
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'update failed', { type: 'error' })
    },
    [notify],
  )

  const [update, { isLoading }] = useUpdate(undefined, undefined, { onError, onSuccess })

  const handleConfirm = useCallback(async (): Promise<void> => {
    await update('job-opportunity-banner', {
      id: jobOpportunityBannerData.id,
      data: { encType: 'multipart/form-data', ...updateData },
      // data: {
      //   ...updateData,
      // },
    })
    handleDialogClose()
  }, [update, updateData, jobOpportunityBannerData])

  if (newsLoading) return null

  const handleSubmit = (data): void => {
    const { ...jobOpportunityBannerdata } = data

    jobOpportunityBannerdata.id = jobOpportunityBannerData?.id
    setUpdateData(jobOpportunityBannerdata as JobOpportunityBanner)
    setOpen(true)
  }

  const putDefaultValue = (): object => ({
    id: jobOpportunityBannerData?.id || '',
    image: jobOpportunityBannerData?.image,
  })

  return (
    <Card>
      <SimpleForm
        onSubmit={handleSubmit}
        toolbar={
          <FormBottomToolbarWithPermission showDeleteButton={false} backgroundColor='#fff' />
        }
        // toolbar={<ApproveAndPublishToolBar encType='multipart/form-data' />}
        defaultValues={putDefaultValue}
      >
        <Confirm
          isOpen={open}
          loading={isLoading}
          title='Update Job Opportunity Banner'
          content='Are you sure you want to update ?'
          onConfirm={handleConfirm}
          onClose={handleDialogClose}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} order={{ xs: -1, sm: 0 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ImageDesktopInput
                  label=''
                  initCrop={false}
                  fallbackSource='full_path'
                  source='image'
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleForm>
    </Card>
  )
}

export default JobOpportunityBannerEdit
